import z from 'zod'

export type Product = {
  id: string
  name: string
  createdAt?: string
  updatedAt?: string
  description?: string
  organizationId?: string
}

export type ProductSimple = {
  id: string
  name: string
}

export const productSchema = z.object({
  name: z.string().min(1, 'Product name is required'),
  description: z.string().optional(),
})

export type ProductFormData = z.infer<typeof productSchema>
